import { render, staticRenderFns } from "./EmailVerificationNotice.vue?vue&type=template&id=1c9db8df"
import script from "./EmailVerificationNotice.vue?vue&type=script&lang=js"
export * from "./EmailVerificationNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports